module.exports = __webpack_public_path__ + "static/media/search_icon_mobile.adc88cf0.svg";